// extracted by mini-css-extract-plugin
export default {"firstCellFlex":"Style_firstCellFlex__bAV+p","row1":"Style_row1__wAfTV"};